// Mock data for House of Microgreens

export const heroData = {
  headline: "Fresh Microgreens Delivered Weekly",
  subtext: "Grown with care. Packed with nutrition. Delivered to your doorstep.",
  heroImage: "https://images.unsplash.com/photo-1622463214111-b192a53371d2?w=1200&q=80"
};

export const benefits = [
  {
    id: 1,
    title: "High in Antioxidants",
    description: "Protect your cells from damage"
  },
  {
    id: 2,
    title: "Improves Immunity",
    description: "Strengthen your body's defense system"
  },
  {
    id: 3,
    title: "Great for Weight Loss",
    description: "Low calories, high nutrients"
  },
  {
    id: 4,
    title: "Skin & Hair Nourishment",
    description: "Natural glow from within"
  },
  {
    id: 5,
    title: "Heart Health",
    description: "Support cardiovascular wellness"
  },
  {
    id: 6,
    title: "40x Nutrient Density",
    description: "More nutrients than mature plants"
  }
];

export const subscriptionPlan = {
  title: "Monthly Subscription",
  mrp: 1999,
  offerPrice: 999,
  features: [
    "Weekly delivery of fresh microgreens",
    "Variety based selection",
    "Eco-friendly packaging",
    "Free delivery across city"
  ]
};

export const samplePack = {
  title: "Try Before You Subscribe",
  description: "A one-time trial pack of fresh microgreens for first-time users. Experience the freshness and quality before committing to a subscription.",
  price: 299
};

export const deliveryCharge = 49;

export const varieties = [
  {
    id: 1,
    name: "Wheatgrass",
    description: "Rich in chlorophyll and vitamins",
    image: "https://images.pexels.com/photos/11579283/pexels-photo-11579283.jpeg?auto=compress&cs=tinysrgb&w=400",
    benefits: "Detoxification, Energy boost",
    price: 199
  },
  {
    id: 2,
    name: "Sunflower",
    description: "Crunchy texture with nutty flavor",
    image: "https://images.pexels.com/photos/9031151/pexels-photo-9031151.jpeg?auto=compress&cs=tinysrgb&w=400",
    benefits: "Protein-rich, Vitamin E",
    price: 249
  },
  {
    id: 3,
    name: "Green Pea",
    description: "Sweet and tender shoots",
    image: "https://images.pexels.com/photos/9031150/pexels-photo-9031150.jpeg?auto=compress&cs=tinysrgb&w=400",
    benefits: "High protein, Folate",
    price: 239
  },
  {
    id: 4,
    name: "Radish",
    description: "Spicy and flavorful",
    image: "https://images.pexels.com/photos/4057823/pexels-photo-4057823.jpeg?auto=compress&cs=tinysrgb&w=400",
    benefits: "Digestive health, Vitamin C",
    price: 249
  },
  {
    id: 5,
    name: "Broccoli",
    description: "Mild flavor, highly nutritious",
    image: "https://images.unsplash.com/photo-1593850685398-e79bab596d1d?w=400&q=80",
    benefits: "Cancer prevention, Antioxidants",
    price: 299
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "We Grow After You Order",
    description: "Your microgreens are sown only after your order is confirmed"
  },
  {
    step: 2,
    title: "Harvested at Peak Nutrition",
    description: "Your microgreens are harvested only after they reach their ideal growth stage, usually 7-10 days after sowing."
  },
  {
    step: 3,
    title: "Delivered fresh",
    description: "Delivered fresh - no cold storage, no old stock."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Suraksha Hegde",
    location: "HSR Layout, Bangalore",
    image: "https://res.cloudinary.com/diepent2w/image/upload/v1768719305/Suraksha_H_v9medt.jpg",
    rating: 5,
    text: "The microgreens arrive fresh, neatly packed, and on time. We took the monthly subscription and found it very reliable. Great option if you're looking to add healthier ingredients to everyday food."
  },
  {
    id: 2,
    name: "Nitish Kumar",
    location: "Koramangala, Bangalore",
    image: "https://res.cloudinary.com/diepent2w/image/upload/v1768719305/Nitish_K_ixk1zc.jpg",
    rating: 5,
    text: "The greens arrived fresh and clean, exactly as expected. We've had a smooth experience with the monthly subscription so far."
  },
  {
    id: 3,
    name: "Priyanka",
    location: "BTM Layout, Bangalore",
    image: "https://res.cloudinary.com/diepent2w/image/upload/v1768719305/Priyanka_B_znhu4s.jpg",
    rating: 5,
    text: "The microgreens are always fresh and neatly packed. Delivery has been smooth, and the quality has been consistent. Simple, reliable, and easy to use in daily cooking."
  },
  {
    id: 4,
    name: "Sajan Karkera",
    location: "JP Nagar, Bangalore",
    image: "https://res.cloudinary.com/diepent2w/image/upload/v1768720227/Sajan_Karkera_saga8m.jpg",
    rating: 5,
    text: "What we like most is the freshness and consistency. The subscription model is simple, and the greens stay fresh for days. Definitely a good choice for anyone focusing on clean eating."
  }
];

export const aboutUs = {
  title: "About House of Microgreens",
  content: "We believe that everyone deserves access to fresh, nutrient-dense food. Our mission is to bring the power of microgreens to your table, grown with care in our hygienic, controlled environment farms. We use only organic methods, ensuring that every batch is packed with maximum nutrition and flavor. Our commitment to freshness means we harvest and deliver within 24 hours, so you get the best nature has to offer.",
  values: [
    { title: "Freshness", description: "Harvested and delivered within 24 hours" },
    { title: "Health", description: "40x more nutrients than mature vegetables" },
    { title: "Purity", description: "100% organic, no pesticides or chemicals" },
    { title: "Sustainability", description: "Eco-friendly practices and packaging" }
  ]
};

export const faqs = [
  {
    id: 1,
    question: "How does the subscription work?",
    answer: "Once you subscribe, we start growing your microgreens specifically for you. The first delivery is scheduled after the growing cycle is complete. After that, you will receive fresh microgreens every week on the same fixed day, based on your subscription schedule."
  },
  {
    id: 2,
    question: "When will I receive my delivery?",
    answer: "For subscription orders, the first delivery is scheduled after your microgreens are freshly grown (usually 7-10 days from order). After the first delivery, you will receive your microgreens every week on the same day, based on your subscription schedule. For one-time orders, delivery is scheduled 7-10 days from the order date, as all microgreens are grown fresh on order. We deliver between 8 AM and 8 PM on the scheduled delivery day. All delivery details and updates will be shared with you via WhatsApp, and you can also reach out to us on the same number for any queries or assistance."
  },
  {
    id: 3,
    question: "How should I store microgreens?",
    answer: "Microgreens should be stored in the refrigerator immediately after delivery. Keep them in their original container or an airtight box and avoid washing them until use. For best taste and nutrition, we recommend consuming them within 5-7 days."
  },
  {
    id: 4,
    question: "What's the cancellation / pause policy?",
    answer: "Our subscription is a one-month plan and is valid for the full subscription period once started. You can pause or skip a delivery with prior notice, depending on the growing schedule. You can also choose not to continue the subscription for the next month. Since microgreens are grown specifically for each order, mid-cycle cancellations or refunds are not supported once the growing process has started. For any changes or pause requests, please contact us on WhatsApp, and we'll be happy to help."
  },
  {
    id: 5,
    question: "Do you deliver in my area?",
    answer: "We currently deliver to select areas in Bangalore. You can check delivery availability by entering your pin code on the website or by reaching out to us on WhatsApp for confirmation."
  },
  {
    id: 6,
    question: "What varieties come in the subscription?",
    answer: "While subscribing, you can choose one microgreen variety that you'd like for the month. That selected variety will be delivered to you every week throughout your subscription period. We also offer multiple microgreen options to choose from, and you can change your preferred variety when starting a new monthly subscription. If you need help selecting the right microgreen based on your taste or health goals, feel free to reach out to us on WhatsApp."
  },
  {
    id: 7,
    question: "What is the difference between subscription and one-time order?",
    answer: "A subscription gives you fresh microgreens delivered every week on a fixed day and offers better value for regular consumption. A one-time order is ideal if you want to try a specific variety or sample microgreens before subscribing. Even one-time orders are delivered after the growing cycle is complete."
  },
  {
    id: 8,
    question: "Why does the first delivery take time?",
    answer: "We grow all our microgreens only after you place an order. This ensures maximum freshness, nutrition, and taste—no pre-grown or cold-stored greens. The first delivery takes time because your food is still growing."
  },
  {
    id: 9,
    question: "Are your microgreens chemical-free?",
    answer: "Yes. Our microgreens are naturally grown in a clean and controlled environment, without the use of pesticides, harmful chemicals, or synthetic growth enhancers. We focus on fresh, small-batch growing practices to ensure clean, safe, and nutrient-rich microgreens."
  },
  {
    id: 10,
    question: "Are microgreens suitable for everyday Indian cooking?",
    answer: "Absolutely. Microgreens can be easily added to dals, sabzis, rotis, salads, curd, smoothies, and juices. No special cooking is required."
  },
  {
    id: 11,
    question: "How do I contact you if I have questions?",
    answer: "All order updates and delivery details are shared via WhatsApp. You can reach out to us anytime on the same number for support, changes, or questions."
  }
];

export const contactInfo = {
  email: "hi@houseofmicrogreens.in",
  phone: "+91 6363312348",
  whatsapp: "+91 6363312348",
  address: "Bengaluru, Karnataka 560076",
  social: {
    instagram: "https://instagram.com/house_of_microgreens",
    facebook: "https://facebook.com/house_of_microgreens"
  }
};
